import EventBus from 'vertx3-eventbus-client';

angular.module('core').factory('sock', ['$rootScope', '$q', '$timeout', 'TROI', 'Token', function ($rootScope, $q, $timeout, TROI, Token) {

  class Sock extends EventTarget {constructor() {

    super();

    var eb;
    var deffered = $q.defer();
    var connect = deffered.promise;

    var channel = null;
    var handlers = [];
    var registeredHandlers = [];

    function registerHandlers() {
      connect.then(function () {
        Object.keys(handlers).forEach(function (key) {
          if (registeredHandlers.indexOf(key) != -1) return;
          eb.registerHandler(channel + '.' + key, function (err, res) {
            if (err) {
              console.error(err);
              return;
            }
            handlers[key].forEach(function (fn) {
              if (typeof fn == 'function') fn(res.body, res.reply);
            });
          }.bind(this));
          registeredHandlers.push(key);
        }.bind(this));
      });
    }

    this.registerHandler = function (address, fn) {
      handlers[address] = handlers[address] || [];
      handlers[address].push(fn);
      if (channel) {
        registerHandlers();
      }
    };

    this.unregisterHandler = function (address, fn) {
      if (!handlers[address]) return;
      var i;
      while ((i = handlers[address].indexOf(fn)) >= 0) {
        handlers[address].splice(i, 1);
      }
    };

    this.send = function (address, data) {
      return connect.then(function () {
        return $q(function (fulfill, reject) {
          eb.send(channel + '.' + address, data, function (err, res) {
            if (err) {
              reject(err);
            } else {
              fulfill(res.body);
            }
          });
        });
      });
    };

    this.online = function () {
      return connect.$$state.status !== 0;
    };

    this.publish = function (address, data) {
      return connect.then(function () {
        eb.publish(channel + '.' + address, data);
        return true;
      });
    };

    this.connectPromise = connect;

    this.connect = function () {

      Token.get().then(function (token) {

        eb = new EventBus(`${TROI}/chat`);

        eb.onclose = function () {
          $timeout(function () {
            this.connect();
          }.bind(this), 1500);
          registeredHandlers = [];
          this.dispatchEvent(new CustomEvent('close'));
          if (connect.$$state.status !== 0) {
            deffered = $q.defer();
            this.connectPromise = connect = deffered.promise;
          }

        }.bind(this);

        eb.onopen = function () {

          eb.send(
            'system.login',
            {
              user: $rootScope.user.uid,
              token: token.getKey()
            },
            function (_err, res) {
              res = res.body;
              if (res.success == false) {
                Token.renew().then(function () {
                  eb.close();
                });
                return;
              }
              channel = res.channel;
              deffered.promise.then(registerHandlers);
              deffered.resolve();
              this.dispatchEvent(new CustomEvent('open'));
            }.bind(this)
          );
        }.bind(this);

        return this;

      }.bind(this))
        .catch(reason => $timeout(() => {
          console.error(reason);
          this.connect();
        }, 1500));
    }.bind(this);

    var that = this;
    this.$on = function (scope, channel, cb) {
      switch (channel) {
        case 'open':
        case 'close':
          console.warn(`deprectated sock.$on(${channel})`);
          return;
      }
      var $applyCb = function (msg) {
        scope.$apply(function () {
          cb(msg);
        });
      };
      that.registerHandler(channel, $applyCb);
      scope.$on('$destroy', function () {
        that.unregisterHandler(channel, $applyCb);
      });
    };

  }}


  return new Sock();
}]);
